import React, { useEffect } from "react";
import classes from "./IntroPage.module.css";
import Layout from "../components/newComponents/Layout";
import Card from "../components/newComponents/Card";
import Lottie from "lottie-react";
import animationData from "../staticAnimations/thinkAnimation.json";
import CardHeader from "../components/newComponents/CardHeader";
import { useNavigate } from "react-router-dom";

const IntroPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      navigate("/home");
    }, 1800);
  }, []);
  return (
    <Layout>
      <Card>
        <CardHeader title="Welcome to Word Game..." />
        <Lottie animationData={animationData} loop={true} autoplay={true} />
      </Card>
    </Layout>
  );
};

export default IntroPage;
